import { Pie, PieChart } from 'recharts'
import { Typography } from 'shared/ui/Typography'
import { Tooltip, type ITooltipProps } from 'shared/ui/Tooltip'
import { Icon } from 'shared/ui/Icon'
import { DonutChartBars } from 'shared/ui/DonutChart/ui/DonutChartBars/DonutChartBars'
import { type IDonutChartBar } from 'shared/ui/DonutChart'
import styles from './styles.module.scss'

export type IDonutChartDataItem = {
  name: string
  value: number
  fill: string
}

type IDonutChartProps = {
  data: IDonutChartDataItem[]
  labelProps?: {
    title: string
    desc?: string
    tooltipProps?: ITooltipProps
  }
  items?: IDonutChartBar[]
}

export const DonutChart = ({ data, labelProps, items }: IDonutChartProps) => {
  const renderLabel = () => {
    if (!labelProps) return null

    return (
      <div className={styles.charLabel}>
        <Typography
          tag={'div'}
          ariaLabel={'DonutChart__title'}
          variant={'heading-md'}
          className={styles.charLabel__title}
        >
          {labelProps.title}
        </Typography>

        <div className={styles.charLabel__wrapDesc}>
          {labelProps.desc && (
            <Typography
              tag={'div'}
              ariaLabel={'DonutChart__desc'}
              variant={'body-sm-regular'}
              className={styles.charLabel__desc}
            >
              {labelProps.desc}
            </Typography>
          )}

          {labelProps.tooltipProps && (
            <Tooltip placement={'top'} {...labelProps.tooltipProps}>
              <Icon
                icon={'question'}
                tertiary
                fontSize={14}
                color={'var(--content-neutral-primary)'}
              />
            </Tooltip>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.char}>
        <PieChart
          width={140}
          height={140}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          responsive
        >
          <Pie
            data={data}
            innerRadius={'73%'}
            outerRadius={'100%'}
            cornerRadius={7}
            paddingAngle={5}
            dataKey='value'
            isAnimationActive={false}
          />
        </PieChart>

        {renderLabel()}
      </div>

      {!!items?.length && (
        <div className={styles.bars}>
          <DonutChartBars items={items} />
        </div>
      )}
    </div>
  )
}
